<span>
  <input type="file" #file (change)="importFileChanged($event)" multiple="false" required hidden accept=".csv" />
  <button type="button" nz-button (click)="file.click()"><i nz-icon nzType="upload"></i><span>Click to Upload</span></button>
  <br /><br />
  <p *ngIf="fileName">
    <i nz-icon nzType="paper-clip" nzTheme="outline"></i>
    &nbsp;&nbsp;{{fileName}}
  </p>
</span>
